import PropTypes from 'prop-types'
import { memo } from 'react'
import Content from './Content/Content'
import Item from './Item/Item'
import Toggle from './Toggle/Toggle'

/**
 * The `Accordion`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function AccordionComponent (props) {
  const { children, className } = props

  return <div className={className}>{children}</div>
}

/** @type {object} */
AccordionComponent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

AccordionComponent.defaultProps = {
  className: '',
  children: null
}

// Memoize
const Accordion = memo(AccordionComponent)

// Bind the types
Accordion.Item = Item
Accordion.Toggle = Toggle
Accordion.Content = Content

// Export
export default Accordion
